export default __webpack_public_path__ + "static/media/07-1.864db370.jpg";